import React from 'react';

import Select from '../../../../common/data-entry/Select';
import { sortOptionsByFavorite } from '../modeReportsServices';

import { StudyOptionTemplate } from './StudyOptionTemplate';

const ModeReportsStudyPcnSingleSelectFilter = ({
  controlId,
  filterLabel,
  dataSource,
  value,
  clearable,
  onChange,
  setOptionsAsFavorite,
  favoriteOptions
}) => {
  return (
    <Select
      className="eui-filter-control-study-pcn"
      controlId={controlId}
      label={filterLabel}
      dataSource={sortOptionsByFavorite(dataSource, favoriteOptions)}
      value={value}
      clearable={clearable}
      searchable={true}
      deselectOnSelectedOptionClick={true}
      clearSelectedValueOnDataSourceChange={false}
      onChange={onChange}
      validate={false}
      customFilterFunction={function(e, index, collection, searchString) {
        const searchLower = (searchString || '').toLowerCase();
        return `${e.pcn} ${e.name}`.toLowerCase().includes(searchLower);
      }}
      customOptionTemplateFunction={option => (
        <StudyOptionTemplate
          option={option}
          setOptionsAsFavorite={setOptionsAsFavorite}
          favoriteOptions={favoriteOptions}
        />
      )}
      customSelectedValueTemplateFunction={([selectedValue]) => {
        if (!selectedValue) return null;
        const { name, pcn } = selectedValue;
        return (
          <span>
            {name}
            {pcn && <span className="eui-filter-control-study-pcn-label"> ({pcn})</span>}
          </span>
        );
      }}
    />
  );
};

export default ModeReportsStudyPcnSingleSelectFilter;
